import { match } from 'ts-pattern'

import { sub } from '@sequencehq/utils/dates'

import { TotalViewsForDate, TotalViewsTimescale } from '../../../types'

export const timescaleToDays = (timescale: TotalViewsTimescale): number => {
  return match(timescale)
    .with('LAST_7_DAYS', () => 7)
    .with('LAST_14_DAYS', () => 14)
    .with('LAST_30_DAYS', () => 30)
    .exhaustive()
}

export const getUnitTickValues = ({
  data
}: {
  data: TotalViewsForDate[]
}): [number, number] => {
  if (data.length === 0) return [0, 0]

  const maxValue = Math.max(...data.map(d => d.totalViews))

  // prevent the middle Y axis value from being a decimal
  const evenMaxValue = maxValue % 2 === 0 ? maxValue : maxValue + 1

  return [evenMaxValue / 2, evenMaxValue]
}

export const getChartData = ({
  data,
  days
}: {
  data: TotalViewsForDate[]
  days: number
}): Array<{
  date: string
  value: number
}> => {
  const dataMap = new Map(data.map(d => [d.date, d.totalViews]))

  const now = new Date()
  const utcNow = new Date(
    Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate())
  )

  return Array.from({ length: days }, (_, index) => {
    const daysAgo = days - 1 - index
    const date = sub(utcNow, { days: daysAgo })
    const dateString = date.toISOString().slice(0, 10)

    return { date: dateString, value: dataMap.get(dateString) ?? 0 }
  })
}
